import React from 'react';

const Shimmer = ({ width, height, borderRadius, marginTop }) => {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: borderRadius || '4px',
        background:
          'linear-gradient(90deg, #f6f7f8 25%, #edeef1 50%, #f6f7f8 75%)',
        backgroundSize: '200% 100%',
        marginTop,
        animation: 'shimmer 1.5s infinite linear',
      }}
    />
  );
};

const shimmerStyle = document.createElement('style');
shimmerStyle.innerHTML = `
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
`;
document.head.appendChild(shimmerStyle);

export default Shimmer;
